let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5W8n7")).then(() => parcelRequire('5TRYB'));